import { Event } from "./Event";

import type { IAddCustomEvent } from "./types";

export class AddCustomEvent extends Event {
  constructor({
    eventType,
    eventProperties,
    customEventProperties,
  }: IAddCustomEvent) {
    super({
      event_type: eventType,
      event_properties: eventProperties,
      custom_event_properties: customEventProperties,
    });
  }
}
